import { useMutation, useQuery } from 'react-query';
import tefServices from './tef.services';
import { AxiosError } from 'axios';
import { notification } from 'antd';

export function useTefPayment() {
  return useMutation({
    mutationFn: tefServices.payment,
    onError(error: AxiosError) {
      notification.error({
        message: 'GP Elgin',
        description:
          error.response?.data?.mensagem ||
          'Não foi possível solicitar o pagamento.',
      });
    },
  });
}

export function useTefActivation(cnpj?: string, enabled = true) {
  return useQuery({
    retry: 0,
    queryKey: ['tef-report', cnpj],
    queryFn: () => tefServices.activation(cnpj),
    enabled: !!cnpj && enabled,
  });
}

export function useTefCancel() {
  return useMutation({
    mutationFn: tefServices.cancel,
    onSuccess(data) {
      if (data.resultado?.tef.retorno !== '1') {
        notification.warning({
          message: 'Cancelamento de pagamento',
          description:
            data?.resultado?.tef?.mensagemResultado ||
            'Não foi possível finalizar o processo de cancelamento da compra',
        });
      } else {
        notification.success({
          message: 'Cancelamento de pagamento',
          description:
            data?.resultado?.tef?.mensagemResultado ||
            'Pagamento cancelado com sucesso!',
        });
      }
    },
    onError(error: AxiosError) {
      notification.error({
        message: 'GP Elgin',
        description:
          error.response?.data?.mensagem ||
          'Não foi possível solicitar o pagamento.',
      });
    },
  });
}
